import React, { useState, forwardRef } from 'react';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import {
  StyledLabel,
  StyledInput,
  VisibilityButton,
  LabelText,
  StyledTextarea,
  LeftIconContainer,
  RightIconContainer,
  Loader,
  LabelContainer,
  TooltipContainer,
  TooltipText,
} from './Input.styles';
import { ReactComponent as VisibilityIcon } from '../../../../assets/icons/visibility.svg';
import { ReactComponent as VisibilityOffIcon } from '../../../../assets/icons/visibility_off.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';
import LoaderGIF from '../../../../assets/gifs/loader.gif';

const Input = forwardRef(
  (
    {
      defaultValue,
      value,
      placeholder,
      onChange,
      autoFocus,
      disabled,
      className,
      error,
      hideErrorMessage,
      label,
      type,
      twoLineError,
      leftIcon,
      rightIcon,
      rightIconLoader,
      onRightIconClick,
      textAreaHeight,
      tooltipText,
      ...inputProps
    },
    ref,
  ) => {
    const [isShown, setIsShown] = useState(false);
    const [focused, setFocused] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onFocus = () => setFocused(true);
    const onBlur = () => {
      setFocused(false);
    };

    const handleKeyDown = e => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        e.currentTarget.form.requestSubmit();
      }
    };

    return (
      <StyledLabel disabled={disabled} className={className}>
        {label && (
          <LabelContainer>
            <LabelText>{label}</LabelText>
            {tooltipText && (
              <InfoIcon
                width={16}
                height={16}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              />
            )}
            {tooltipText && showTooltip && (
              <TooltipContainer>
                <TooltipText>{tooltipText}</TooltipText>
              </TooltipContainer>
            )}
          </LabelContainer>
        )}
        {leftIcon && <LeftIconContainer $labelExists={!!label}>{leftIcon}</LeftIconContainer>}
        {type === 'textarea' ? (
          <StyledTextarea
            ref={ref}
            placeholder={placeholder}
            type={type}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            disabled={disabled}
            onFocus={onFocus}
            onBlurCapture={onBlur}
            onKeyDown={handleKeyDown}
            $textAreaHeight={textAreaHeight}
            {...inputProps}
          />
        ) : (
          <StyledInput
            ref={ref}
            placeholder={placeholder}
            type={type === 'password' ? (isShown ? 'text' : 'password') : type}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            disabled={disabled}
            onFocus={onFocus}
            onBlurCapture={onBlur}
            $isShown={isShown}
            $isFocused={focused}
            $leftIcon={!!leftIcon}
            $rightIcon={!!rightIcon}
            autoComplete="off"
            {...inputProps}
          />
        )}
        {rightIcon && (
          <RightIconContainer onClick={onRightIconClick} $labelExists={!!label} $rightIconLoader={!!rightIconLoader}>
            {rightIconLoader ? <Loader src={LoaderGIF} /> : rightIcon}
          </RightIconContainer>
        )}
        {type === 'password' && (
          <VisibilityButton onClick={() => setIsShown(prev => !prev)} $labelExists={!!label}>
            {isShown ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </VisibilityButton>
        )}
        {!hideErrorMessage && <ErrorContainer errorText={error} twoLine={twoLineError} />}
      </StyledLabel>
    );
  },
);

export default Input;
